export default "__VITE_ASSET__D1AZSfEe__"